// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QR-z","isFullWidth":"RR-z","landingPageVideo":"SR-z","play":"TR-z","iframeVideo":"UR-z","playHidden":"VR-z","fullwidth":"WR-z"};